import { Grid } from "@mui/material";
import { BoardColumn } from "./components/board.column";
import { BoardConsumer, BoardProvider } from "./contexts/board.context";

type BoardProps = {
  search: string | null;
  filters: {
    qualification?: string[];
  }
};

export function Board({
  search,
  filters
}: BoardProps) {
  return (
    <BoardProvider search={search} filters={filters} >
      <BoardConsumer>
        {({ columns }) => (
          <Grid
            container
            columns={columns.length}
            wrap="nowrap"
            id="test"
            height={"100%"}
            gap={2.5}
          >
            {columns.map((column) => (
              <BoardColumn key={column.id} column={column} />
            ))}
          </Grid>
        )}
      </BoardConsumer>
    </BoardProvider>
  );
}
